import React from "react";

const ProcessingBar = () => {
  return (
    <div className="font-sans relative">
      <div className="h-3 w-[100px] absolute inset-0 m-auto">
        {[...Array(6)].map((_, idx) => (
          <div
            key={idx}
            className={`absolute h-3 w-3 rounded-full 
            animate-loaderDot
            ${dotColor(idx)}
            `}
            style={{ animationDelay: `${2 - idx * 0.1}s` }}
          />
        ))}
      </div>
    </div>
  );
};

// Helper function to map dot colors
const dotColor = (index) => {
  const colors = [
    "bg-[#fed693]", // Lightest
    "bg-[#f9be6e]",
    "bg-[#f3a649]",
    "bg-[#ed8e24]",
    "bg-[#e5760a]",
    "bg-[#fed693]", // Darkest
  ];
  return colors[index] || "bg-black";
};

export default ProcessingBar;
